import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planMutationKeys, planQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useUpdatePlanDetailsMutation = (options) => {
  const handleMutation = async ({ planId, planDetails }) => {
    const config = {
      method: 'patch',
      data: planDetails
    }
    const { data } = await api(`/api/v2/plans/${planId}`, config)

    return data
  }

  const invalidateRelatedQueries = (planId) => {
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLAN_DETAILS, planId]
    })

    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_INFINITY_QUERY]
    })

    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_CHILDREN_TREE_QUERY]
    })
  }

  return useMutation({
    mutationKey: [planMutationKeys.UPDATE_PLAN_DETAILS],
    mutationFn: handleMutation,
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateRelatedQueries(variables.planId)

      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
    }
  })
}
